var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:{ disabled: _vm.disabled },on:{"click":_vm.toggle}},[_c('div',{staticClass:"check",class:{checked: this.checked}}),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }